import { Box } from '@mui/material';
import { WizardWithData } from '../../../../../../core/hooks/WizardWithData';
import { AodRuleWizardValues } from './types';
import { aodRuleSteps } from './wizard/steps/AodRuleSteps';
import { WizardHeader } from './wizard/WizardHeader';

export function AodRuleWizard({ initialData }: { initialData: AodRuleWizardValues | undefined }) {
  const steps = aodRuleSteps;

  return (
    <WizardWithData<AodRuleWizardValues>
      initialData={initialData}
      header={<WizardHeader steps={steps} />}
      wrapper={<Box mt={4} />}
    >
      {steps.map((step) => (
        <step.Content key={step.id} />
      ))}
    </WizardWithData>
  );
}
